if (!customElements.get('laserlab-sticky-book')) {
  customElements.define('laserlab-sticky-book', class extends HTMLElement {
    connectedCallback() {
      this.mobile = window.matchMedia('(max-width: 767.98px)');
      // The booking app renders its own visible "Velg en tid" button after load: wait for it (up to ~15 s).
      const visible = (element) => element && element.offsetParent !== null && element.getBoundingClientRect().height > 0;
      this.mode = this.dataset.mode || 'book';
      // Shop products: the main add-to-cart button of the product form. Treatments: the booking app's button.
      this.selector = this.mode === 'cart'
        ? '.product__block--buy_buttons form[action*="/cart/add"] [type="submit"], .product__block--buy_buttons .product-form__submit'
        : '.servicify-select-a-time-button, .servicify-popup-calendar-button';
      this.trigger = [...document.querySelectorAll(this.selector)].find(visible);
      if (!this.trigger) {
        if ((this.retries = (this.retries || 0) + 1) <= 30) setTimeout(() => this.connectedCallback(), 500);
        return;
      }
      if (this.observer) return;
      // The page's own heading: on shop products it is the name without the brand (the brand sits above it).
      const title = document.querySelector('h1.product__title') || document.querySelector('.product__info-wrapper h1, .product__info-container h1');
      const name = this.querySelector('[data-sticky-book-name]');
      if (title && name) {
        const copy = title.cloneNode(true);
        copy.querySelectorAll('.ll-shop-product__brand, .visually-hidden').forEach((element) => element.remove());
        name.textContent = copy.textContent.replace(/\s+/g, ' ').trim();
      }
      this.querySelector('[data-sticky-book-button]').addEventListener('click', () => {
        const target = [...document.querySelectorAll(this.selector)].find(visible) || this.trigger;
        if (target.disabled) return;
        target.click();
      });
      this.triggerAbove = false;
      this.footerVisible = false;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.trigger) this.triggerAbove = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          else this.footerVisible = entry.isIntersecting;
        });
        this.update();
      });
      this.observer.observe(this.trigger);
      const footer = document.querySelector('#LaserlabFooter, .footer-section, footer');
      if (footer) this.observer.observe(footer);
      this.onChange = () => this.update();
      this.mobile.addEventListener('change', this.onChange);
      // Hide while the booking panel (or any drawer) is open.
      this.bodyObserver = new MutationObserver(this.onChange);
      this.bodyObserver.observe(document.body, { childList: true, attributes: true, attributeFilter: ['class', 'style'] });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.bodyObserver?.disconnect();
      this.mobile?.removeEventListener('change', this.onChange);
    }
    /* Cart mode: the bar says what the main button says (Legg i handlekurv, Utsolgt) and is off when it is. */
    mirror() {
      if (this.mode !== 'cart' || !this.trigger) return;
      const button = this.querySelector('[data-sticky-book-button]');
      const label = (this.trigger.querySelector('span:not(.visually-hidden)') || this.trigger).textContent.trim();
      if (label && button.textContent !== label) button.textContent = label;
      button.disabled = this.trigger.disabled || this.trigger.getAttribute('aria-disabled') === 'true';
    }
    update() {
      this.mirror();
      // A booking dialog the panel had to dismiss (data-ll-dismissed, see laserlab-booking.js) no longer counts as open.
      const panelOpen = !!document.querySelector('.ReactModal__Content:not([data-ll-dismissed] .ReactModal__Content)') || document.body.classList.contains('overflow-hidden');
      const show = this.mobile.matches && this.triggerAbove && !this.footerVisible && !panelOpen;
      if (this.hidden === !show) return;
      this.hidden = !show;
      document.documentElement.classList.toggle('ll-sticky-book-visible', show);
    }
  });
}
